/* ============================================================
   pj-member-discount.js — PATH B member discount auto-apply.

   For a signed-in member, applies their Circle tier discount CODE(s) to the cart
   so the tier % (+ Legacy/Heritage free shipping) apply at checkout WITHOUT a
   Shopify Function (which needs Plus / a public app + app review). The codes are
   customer-SEGMENT-gated server-side (provision-member-codes.js), so applying one
   for a non-eligible shopper is a safe no-op — eligibility is enforced at checkout.

   Reads window.PJ = { tier, loggedIn } (injected by layout/theme.liquid). The real
   discount renders natively in Dawn's cart + checkout (no display estimate here).

   GATING: MEMBER_CODES_LIVE is TRUE — Path B is LIVE. Codes + segments were
   provisioned on the live store 2026-06-23, operator-verified (per-tier checkout
   + non-member no-op), and the flag was flipped live 2026-07-06 (go-live day,
   runbook step 6). MUTUALLY EXCLUSIVE with the Path A Function (MEMBERSHIP_LIVE
   in pj-cart.js — must stay false): never enable both, or discounts double-apply.
   See plan/database/member-codes-path-b.md.
   ============================================================ */
(function () {
  'use strict';

  var MEMBER_CODES_LIVE = true; // LIVE 2026-07-06 — provisioned 2026-06-23 + operator-verified; keep MEMBERSHIP_LIVE=false in pj-cart.js

  // Shared flag for pj-cart.js: lets the cart show an honest "your discount
  // appears at checkout" note (code discounts render at checkout, not in-cart).
  window.PJ_CODES_LIVE = MEMBER_CODES_LIVE;

  // tier slug (frozen internal) -> code(s). Legacy/Heritage stack % + free shipping.
  var CODES = {
    rider: ['CIRCLE-HEIR'],
    wrangler: ['CIRCLE-LEGACY', 'CIRCLE-FREESHIP'],
    rancher: ['CIRCLE-HERITAGE', 'CIRCLE-FREESHIP'],
  };

  function apply() {
    if (!MEMBER_CODES_LIVE) return;
    var cfg = window.PJ || {};
    if (!cfg.loggedIn) return;
    var tier = (cfg.tier || '').toString().toLowerCase();
    var codes = CODES[tier];
    if (!codes || !codes.length) return;

    // Apply once per browser session; the cart keeps the codes through checkout.
    var key = 'pj_circle_codes_' + tier;
    try { if (sessionStorage.getItem(key) === '1') return; } catch (e) { /* private mode */ }

    // Sequential, combinable: GET /discount/<code> applies that code to the cart
    // session server-side and persists it to checkout. Combinable codes accumulate.
    var i = 0;
    function next() {
      if (i >= codes.length) {
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
        if (window.PJStore && typeof PJStore.refreshCart === 'function') PJStore.refreshCart();
        return;
      }
      var code = codes[i++];
      fetch('/discount/' + encodeURIComponent(code), { method: 'GET', credentials: 'same-origin', redirect: 'follow' })
        .then(function () { next(); })
        .catch(function () { next(); }); // best-effort — a non-eligible code simply no-ops
    }
    next();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
